import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogBluebeamTakeoffs() {
  useEffect(() => {
    document.title = 'The Science of Precision: Why Digital Bluebeam Takeoffs Beat Manual Counting | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Material waste is a silent profit killer. Learn how digital Bluebeam Revu takeoffs ensure exact lumber and plywood orders, reducing waste and emergency supplier runs for Vancouver construction projects.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Bluebeam Revu takeoffs, construction material estimation, formwork BOQ services, digital takeoffs Vancouver, material waste reduction');
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'The Science of Precision: Why Digital Bluebeam Takeoffs Beat Manual Counting',
      description: 'Material waste is a silent profit killer. Learn how digital Bluebeam Revu takeoffs ensure exact lumber and plywood orders, reducing waste and emergency supplier runs.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2024-04-20',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog-takeoffs"]')) {
      script.setAttribute('data-schema', 'blog-takeoffs');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-takeoffs"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
